export const ACTIVE_CHAT_COOKIE = 'activeChat';
